<div class="flex h-dvh bg-gray-100">

  <!-- Mobile sidebar backdrop -->
  <div *ngIf="sidebarOpen()" (click)="closeSidebar()"
       class="fixed inset-0 z-30 bg-gray-900/50 backdrop-blur-sm lg:hidden"></div>

  <!-- Sidebar -->
  <aside class="fixed inset-y-0 left-0 z-40 w-72 max-w-[85vw] bg-gray-900 flex flex-col transition-transform duration-300 ease-in-out lg:static lg:w-64 lg:flex-shrink-0 lg:translate-x-0"
         [class.translate-x-0]="sidebarOpen()"
         [class.-translate-x-full]="!sidebarOpen()">

    <!-- Brand -->
    <div class="h-16 flex items-center gap-3 px-6 border-b border-gray-700">
      <div class="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
        </svg>
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-white font-semibold text-sm leading-tight">Committee</p>
        <p class="text-gray-400 text-xs">Management System</p>
      </div>
      <button type="button" (click)="closeSidebar()" aria-label="Close menu"
              class="lg:hidden tap-target inline-flex items-center justify-center p-2 -mr-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-colors">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Nav -->
    <nav class="flex-1 px-3 py-4 overflow-y-auto">

      <!-- OVERVIEW -->
      <div class="space-y-1">
        <p class="px-3 mb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Overview</p>
        <a routerLink="/home" routerLinkActive="bg-blue-600 text-white" [routerLinkActiveOptions]="{exact: true}"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
          </svg>
          <span class="text-sm font-medium">Dashboard</span>
        </a>
      </div>

      <!-- OPERATIONS -->
      <div class="pt-3 mt-3 border-t border-gray-700 space-y-1">
        <p class="px-3 mb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Operations</p>

        <a *appHasPermission="[201, 202]" routerLink="/members" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <span class="text-sm font-medium">Members</span>
        </a>

        <a routerLink="/events" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
          <span class="text-sm font-medium">Events</span>
        </a>
      </div>

      <!-- FINANCE -->
      <div class="pt-3 mt-3 border-t border-gray-700 space-y-1">
        <p class="px-3 mb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Finance</p>

        @if (isSuperAdmin || isTenantAdmin) {
          <a routerLink="/payments" routerLinkActive="bg-blue-600 text-white"
             class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
            <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span class="text-sm font-medium">Payments</span>
          </a>
        } @else if (myMemberId(); as id) {
          <a [routerLink]="['/members', id]" routerLinkActive="bg-blue-600 text-white"
             class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
            <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span class="text-sm font-medium">Payments</span>
          </a>
        } @else if (hasPaymentListPermission) {
          <a routerLink="/payments" routerLinkActive="bg-blue-600 text-white"
             class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
            <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span class="text-sm font-medium">Payments</span>
          </a>
        }

        <a *appHasPermission="[401]" routerLink="/ledger" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          <span class="text-sm font-medium">Ledger</span>
        </a>

        <a *appHasPermission="[411]" routerLink="/expenses" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
          </svg>
          <span class="text-sm font-medium">Expenses</span>
        </a>
      </div>

      <!-- INSIGHTS -->
      <div *appHasPermission="[501]" class="pt-3 mt-3 border-t border-gray-700 space-y-1">
        <p class="px-3 mb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Insights</p>

        <a routerLink="/reports" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
          </svg>
          <span class="text-sm font-medium">Reports</span>
        </a>
      </div>

      <!-- ACCOUNT -->
      <div class="pt-3 mt-3 border-t border-gray-700 space-y-1">
        <p class="px-3 mb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Account</p>

        <a routerLink="/account/profile" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
          </svg>
          <span class="text-sm font-medium">My Profile</span>
        </a>

        <a routerLink="/settings" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <span class="text-sm font-medium">Settings</span>
        </a>

        <a *ngIf="isSuperAdmin || isTenantAdmin"
           routerLink="/billing" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
          </svg>
          <span class="text-sm font-medium">Billing</span>
        </a>
      </div>

      <!-- ADMINISTRATION -->
      <div *ngIf="isSuperAdmin || isTenantAdmin" class="pt-3 mt-3 border-t border-gray-700 space-y-1">
        <p class="px-3 mb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Administration</p>

        <a routerLink="/admin/member-change-requests" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
          </svg>
          <span class="text-sm font-medium">Change Requests</span>
        </a>

        <a routerLink="/admin/business-units" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <span class="text-sm font-medium">Business Units</span>
        </a>

        <a routerLink="/admin/custom-fields" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 002 2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
          </svg>
          <span class="text-sm font-medium">Custom Fields</span>
        </a>

        <a *ngIf="isSuperAdmin" routerLink="/admin/tenants" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
          </svg>
          <span class="text-sm font-medium">Tenants</span>
        </a>

        <a *ngIf="isSuperAdmin" routerLink="/admin/subscription-plans" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
          <span class="text-sm font-medium">Subscription Plans</span>
        </a>

        <a *ngIf="isSuperAdmin" routerLink="/admin/subscriptions/queue" routerLinkActive="bg-blue-600 text-white"
           class="flex items-center gap-3 px-3 py-3 lg:py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <span class="text-sm font-medium">Subscription Queue</span>
          <span *ngIf="subscriptionQueueCount() > 0"
                class="ml-auto px-1.5 py-0.5 text-xs font-bold bg-red-500 text-white rounded-full">
            {{ subscriptionQueueCount() }}
          </span>
        </a>
      </div>

    </nav>

  </aside>

  <!-- Main content -->
  <div class="flex-1 flex flex-col min-w-0 overflow-hidden">

    <!-- Top bar -->
    <header class="h-16 bg-white border-b border-gray-200 flex items-center px-4 sm:px-6 gap-2 sm:gap-3 flex-shrink-0">

      <!-- Hamburger (mobile only) -->
      <button type="button" (click)="toggleSidebar()" aria-label="Open menu"
              class="lg:hidden tap-target -ml-1 inline-flex items-center justify-center p-2.5 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors flex-shrink-0">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>

      <!-- Workspace context (tenant + BU) — click to open selector modal -->
      <app-context-pill></app-context-pill>

      <!-- Plan pill -->
      <a *ngIf="selectedBusinessUnitId && planName && (isSuperAdmin || isTenantAdmin)"
         routerLink="/billing"
         [title]="'Plan: ' + planName + ' · ' + planStatus"
         class="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border transition-colors"
         [ngClass]="planPillClass">
        <span class="font-semibold tracking-wide">{{ planName }}</span>
        <span class="opacity-70">·</span>
        <span>{{ planStatus }}</span>
        <span *ngIf="planStatus === 'Active' && planDaysLeft !== null && planDaysLeft <= 14"
              class="ml-1 opacity-80">{{ planDaysLeft }}d</span>
      </a>

      <div class="flex-1"></div>

      <!-- User info chip -->
      <div class="relative" data-user-menu>
        <button (click)="toggleUserMenu($event)"
                class="flex items-center gap-2.5 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors">
          <!-- Avatar -->
          <div class="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
               [style.background-color]="avatarUrl ? 'transparent' : avatarColor">
            <img *ngIf="avatarUrl; else avatarInitials" [src]="avatarUrl" alt="" class="w-full h-full object-cover"/>
            <ng-template #avatarInitials>{{ userInitials }}</ng-template>
          </div>
          <!-- Name + role -->
          <div class="text-left hidden sm:block">
            <p class="text-sm font-medium text-gray-900 leading-tight">{{ user?.fullName || user?.username }}</p>
            <p class="text-xs text-gray-500 leading-tight">
              {{ isSuperAdmin ? 'System Admin' : (tenant?.tenantName || 'User') }}
            </p>
          </div>
          <!-- Chevron -->
          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>

        <!-- Dropdown -->
        <div *ngIf="showUserMenu"
             class="absolute right-0 top-full mt-1 w-56 bg-white border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden">
          <div class="px-4 py-3 border-b border-gray-100">
            <p class="text-sm font-semibold text-gray-900">{{ user?.fullName || user?.username }}</p>
            <p class="text-xs text-gray-500 truncate">{{ user?.email }}</p>
          </div>
          <a routerLink="/account/profile" (click)="showUserMenu = false"
             class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
            My Profile
          </a>
          <button type="button" (click)="openContextSelector()"
                  class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
            </svg>
            Switch workspace
          </button>
          <button (click)="logout()"
                  class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
            Sign Out
          </button>
        </div>
      </div>

    </header>

    <!-- Page content -->
    <main class="flex-1 overflow-y-auto p-4 sm:p-6">
      <router-outlet></router-outlet>
    </main>

  </div>

  <!-- Subscription status modal (Grace / Expired) -->
  <app-subscription-status-modal
    *ngIf="statusModal.visibleKind() as k"
    [kind]="k"
    [planName]="statusModal.planName()"
    [currentPeriodEnd]="statusModal.currentPeriodEnd()"
    [graceEndsAt]="statusModal.graceEndsAt()"
    (dismiss)="onModalDismiss()"
    (continueReadOnly)="onModalDismiss()"
    (logout)="onModalLogout()">
  </app-subscription-status-modal>

  <!-- Plan limit / feature-not-included modal -->
  <app-plan-limit-modal
    *ngIf="planLimitModal.state() as s"
    [state]="s"
    [canManageBilling]="planLimitModal.canManageBilling()"
    (dismiss)="planLimitModal.dismiss()">
  </app-plan-limit-modal>

  <!-- Tenant + Business Unit selector modal -->
  <app-context-selector-modal></app-context-selector-modal>

</div>
